export default {
    activix: 'Activix',
    autopropulsion: 'Autopropulsion',
    quicktrade: 'Torque',
    cdkCustomer: 'CDK - Customer',
    cdkRvService: 'CDK - Service',
    ctwizard: 'CTWizard',
    dealerVu: 'DealerVu',
    deskit: 'Deskit',
    easydeal: 'Easy Deal',
    fcaDigital: 'Fiat Chrysler Canada',
    forddirect: 'Ford Canada',
    gmcanada: 'GM Canada',
    lucy: 'Lucy',
    mbcaDigital: 'Mercedes Canada',
    nciDigital: 'Nissan-Infiniti Canada',
    oneEighty: 'One-Eighty',
    polestar: 'Polestar',
    porscheDigital: 'Porsche Canada',
    kiaDigital: 'Kia Canada',
    sciMarketviewSale: 'Taq Auto - Sale',
    sciMarketviewService: 'Taq Auto - Service',
    scraper: 'Scraper',
    sertiRvService: 'Serti - Service',
    sertiVente: 'Serti - Sale',
    vauto: 'vAuto',
    polarisDigital: 'Polaris',
    pbs: 'PBS',
    pbsService: 'PBS - Service',
    pbs_service: 'PBS - Service',
    pbsWorkOrder: 'PBS - Work Order',
    pbs_work_order: 'PBS - Work Oder',
    merlin: 'Merlin',
    maserati_digital: 'Maserati Digital',
    one_eighty_inventory: 'One-Eighty - Inventory',
    cdk_inventory: 'CDK - Inventory',
    serti_inventory: 'Serti - Inventory',
    pbs_inventory: 'PBS - Inventory',
    easydeal_inventory: 'EasyDeal - Inventory',
    serti_renewal: 'Serti - Renewal',
    bmwCanada: 'BMW Canada',
    fni_prestige: 'FNI Prestige',
    stellantisDigital: 'Stellantis Digital',
    jaguarLandRoverDigital: 'Jaguar Land Rover Digital',
    ringcentral: 'RingCentral',
    vbdc: 'VBDC',

    All: 'All',
    sci_marketview_sale: 'Taq Auto - Sale',
    sci_marketview_service: 'Taq Auto - Service',
    easy_deal: 'Easy Deal',
    dealer_vu: 'DealerVu',
    mbca_digital: 'Mercedes Canada',
    fca_digital: 'Fiat Chrysler Canada',
    porsche_digital: 'Porsche Canada',
    polaris_digital: 'Polaris Canada',
    kia_digital: 'Kia Canada',
    harleyDavidsonDigital: 'Harley Davidson Canada',
    harley_davidson_digital: 'Harley Davidson Canada',
    nci_digital: 'Nissan-Infiniti Canada',
    nissan_digital: 'Nissan-Infiniti Canada',
    cdk_service_appt: 'CDK - Service',
    cdk_rv_service: 'CDK - Service',
    one_eighty: '1-80',
    serti_service: 'Serti - Service',
    serti_rv_service: 'Serti - Service',
    stellantis_digital: 'Stellantis Digital',
    jaguar_land_rover_digital: 'Jaguar Land Rover Digital',
    ct_wizard: 'CTWizard',
    ford_direct: 'Ford Canada',
    serti_vente: 'Serti - Sale',
    serti_sale: 'Serti - Sale',
    bmw_canada: 'BMW Canada',
    sertiRenewal: 'Serti - Renewal',
    fniPrestige: 'FNI Prestige',
    maseratiDigital: 'Maserati Digital',
    oneEightyInventory: 'One-Eighty - Inventory',
    cdkInventory: 'CDK - Inventory',
    sertiInventory: 'Serti - Inventory',
    pbsInventory: 'PBS - Inventory',
    easydealInventory: 'EasyDeal - Inventory',
    mitsubishi: 'Mitsubishi',
    hyundai: 'Hyundai',
    deskitInventory: 'Deskit - Inventory',
    deskit_inventory: 'Deskit - Inventory',
    oneSourceInventory: 'One Source - Inventory',
    onesourceInventory: 'One Source - Inventory',
    one_source_inventory: 'One Source - Inventory',
    lautopak_inventory: 'Lautopak - Inventory',
    lautopakInventory: 'Lautopak - Inventory',
    autoverify_inventory: 'Auto Verify - Inventory',
    autoverifyInventory: 'Auto Verify - Inventory',
    volkswagen: 'Volkswagen',
    audi_canada: 'Audi Canada',
    audiCanada: 'Audi Canada',
    ncar: 'NCAR',
    homenet_inventory: 'HomeNet - Inventory',
    homenetInventory: 'HomeNet - Inventory',
    tekion_inventory: 'Tekion - Inventory',
    tekionInventory: 'Tekion - Inventory',
    vauto_inventory: 'vAuto - Inventory',
    vautoInventory: 'vAuto - Inventory',
    dealer_vu_inventory: 'DealerVu - Inventory',
    dealerVuInventory: 'DealerVu - Inventory',
    reynolds_sale: 'Reynolds - Sale',
    reynoldsSale: 'Reynolds - Sale',
    reynolds_inventory: 'Reynolds - Inventory',
    reynoldsInventory: 'Reynolds - Inventory',
    reynolds_service: 'Reynolds - Service',
    reynoldsService: 'Reynolds - Service',

    hondaCanada: 'Honda Canada',
    acuraCanada: 'Acura Canada',
    honda_canada: 'Honda Canada',
    acura_canada: 'Acura Canada',
    cdkDrive: 'CDK Drive',
    cdk_drive: 'CDK Drive',
    canadianBlackBook: 'Canadian Black Book',
    autovance: 'AutoVance',
    tekion: 'Tekion',
    autosync: 'AutoSync',

    export: {
        autovance: 'AutoVance',
        deskit: 'Deskit',
        lucy: 'Lucy',
        oneEighty: 'One-Eighty',
        sertiVente: 'Merlin',
        merlin: 'Merlin',
        autopropulsion: 'Autopropulsion',
        quicktrade: 'Torque',
        vauto: 'vAuto',
        pbs: 'PBS',
        fniPrestige: 'FNI Prestige',
        cdkDrive: 'CDK Drive',
        cdk_drive: 'CDK Drive',
        hyundai: 'VIN',
        volkswagen: 'VIN',
        audi_canada: 'VIN',
        audiCanada: 'VIN',
        tekion: 'Tekion',
        reynoldsSale: 'Reynolds',
        reynolds_sale: 'Reynolds',
    },

    validation: {
        missingPhone: 'Valid phone number is required.',
        missingEmail: 'Valid email address is required.',
        missingNames: 'First name and last name are required.',
        missingLastName: 'Last name is required.',
        missingAllowedMileage: 'Allowed KM is required for Leasing deal type.',
        missingPhones: 'Phone number is required.',
        missingPostalCode: 'Postal code is required.',
        missingWantedVehicle: 'Vehicle of Interest is required.',
        missingDealType: 'Deal type is required.',
        missingLenderForLease: 'Lender is required.',
        missingDealStatus: 'Deal status is required.',
        missingModality: 'Modality is required.',
        missingFrequency: 'Payment frequency is required.',
        missingTerm: 'Term is required.',
        biMonthlyNotSupportByTekion: 'Bimonthly not supported by Tekion',
        missingExchangeVin: 'Trade-in Vehicle VIN is required.',
    },

    tooltip: {
        doublesubmit: 'You can only submit the vehicle once',
        mandatory: 'You need to provide the make, model, year and VIN of the vehicle before submitting',
        mandatoryOnlyVin: 'You need to provide the VIN of the vehicle before submitting',
        mandatoryWithOdometer: 'You need to provide the make, model, year, odometer and VIN of the vehicle before submitting',
        received: 'Evaluation done by {0} on {1}',
        valuesCannotBeNegatives: 'Value and profit cannot have negative values.',
        validVin: 'Invalid VIN. A valid VIN is made of 17 characters.',
        pbsLastNameRequired: 'Lead must have a last name.',
        pbsBusinessNameRequired: 'Business leads must have a business name',
        sertiUserRequired: 'Lead must have an associate assigned.',
        cdkDriveExportDisabled: 'Lead must have a full name, a valid phone number and email and a full address (including city, province, and postal code)',
        leadNotFrom: 'The lead should be from {name}',
        leadAlreadyExported: 'Lead already exported to {name}',
    },

    label: {
        unsubmitted: 'Not submitted',
        waiting: 'Evaluation submitted on {0}, waiting...',
        received: 'Evaluation received',
    },

};
